import React from "react";

function VeryGoodIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 37.732 37.732">
      <path
        d="M18.866,0A18.866,18.866,0,1,1,0,18.866,18.866,18.866,0,0,1,18.866,0Z"
        fill="#00bf56"
      />
      <path
        d="M17.814,4.91A13.054,13.054,0,1,0,30.867,17.964,13.054,13.054,0,0,0,17.814,4.91Zm0,24.239A11.185,11.185,0,1,1,29,17.964,11.185,11.185,0,0,1,17.814,29.149Z"
        transform="translate(1.052 1.086)"
        fill="#fff"
      />
      <ellipse
        cx="1.868"
        cy="1.868"
        rx="1.868"
        ry="1.868"
        transform="translate(12.345 15.313)"
        fill="#fff"
      />
      <ellipse
        cx="1.868"
        cy="1.868"
        rx="1.868"
        ry="1.868"
        transform="translate(21.662 15.313)"
        fill="#fff"
      />
      <path
        d="M19.7,18.261a.928.928,0,0,0-1.307-.22h0a3.737,3.737,0,0,1-4.42,0,.928.928,0,0,0-1.319.1.94.94,0,0,0,.1,1.319h0a5.568,5.568,0,0,0,6.765,0,.94.94,0,0,0,.183-1.2Z"
        transform="translate(2.747 3.938)"
        fill="#fff"
      />
    </svg>
  );
}

export { VeryGoodIcon };
